/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class SmsMessagesService {

    /**
     * Gets an sms message
     * @param id SMS message ID
     * @param xAccessToken API Token
     * @returns any sms message retrieved
     * @throws ApiError
     */
    public static getInternalApiWxSmsMessages(
        id: string,
        xAccessToken?: string,
    ): CancelablePromise<{
        applicant_number?: string | null;
        body?: string | null;
        country_code?: string | null;
        from_number?: string | null;
        funnel_id?: string | null;
        id: string;
        media_type?: string | null;
        media_url?: string | null;
        message_type?: string | null;
        phone_platform?: string | null;
        sent_at?: string;
        stage_id?: string | null;
        to_number?: string | null;
    }> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/internal_api/wx/sms_messages/{id}',
            path: {
                'id': id,
            },
            headers: {
                'X-ACCESS-TOKEN': xAccessToken,
            },
            errors: {
                401: `unauthorized`,
                404: `sms message not found`,
            },
        });
    }

    /**
     * Streams the media file for an MMS message
     * @param id SMS message ID
     * @param xAccessToken API Token
     * @returns any media file streamed
     * @throws ApiError
     */
    public static getInternalApiWxSmsMessagesMedia(
        id: string,
        xAccessToken?: string,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/internal_api/wx/sms_messages/{id}/media',
            path: {
                'id': id,
            },
            headers: {
                'X-ACCESS-TOKEN': xAccessToken,
            },
            errors: {
                401: `unauthorized`,
                404: `sms message not found or has no media`,
            },
        });
    }

}